import React, {useState, useRef, useEffect} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import { 
    Flex, Box, Heading, Text, HStack, VStack, Image, Wrap, WrapItem, Center, Select, Checkbox, Divider,
    SimpleGrid, List, ListItem, ListIcon, Link, Spacer,
    useDisclosure,
} from '@chakra-ui/react';
import { MdNoteAlt, MdSearch, MdCheckCircle } from 'react-icons/md';

import { setNavTab } from '../../redux/actions';
import { getCurrentNavTab } from '../../redux/selectors';
import { ACTIVE_DISPLAY_PATIENT_RESULT_TAB } from '../../redux/constants';

import { FormattedDate } from 'react-intl';
import { decrypt } from '../../utils/crypto';
import { apiLoadAPatientResult } from '../../redux/apis/PatientResultApis';
import { getAPatientResult } from '../../redux/selectors';

import Header from './Header';
import Navbar from './Navbar';
import NoDataPage from '../../components/NoData';
import _404Page from '../../components/404Page';

function DisplayPatientResult(props) {
    const [ notFoundResult, setNotFoundResult ] = useState(false);
    const mounted = useRef();
    const { encrypt_url } = useParams();
    
    useEffect(() => {
        if(!mounted.current) {
            try {
                const cipherText = atob(encrypt_url);
                const patientResultId = decrypt(cipherText, process.env.REACT_APP_SECRET_KEY);
                if(patientResultId) {
                    props.apiLoadAPatientResult({ id: patientResultId });
                } else {
                    setNotFoundResult(true);
                }
                props.setNavTab(ACTIVE_DISPLAY_PATIENT_RESULT_TAB);
                mounted.current = true;
            } catch(error) {
                console.log(error)
                setNotFoundResult(true);
            }
        }
    });

    if(notFoundResult) {
        return (
            <_404Page />
        )
    }

    const { companyDetail, patientDetail, doctorDetail, date_return, results, file_results, medicine_results, cure_day, food_avoid } = props.patientResultDetail || {};

    return (
        <React.Fragment>
            <Box>
                <Header />
                <Navbar />

                <Box width="100%" height="100%" bg="#ffffff" px={2} py={2}>
                    <Box borderRadius={8} px={{ base: 2, md: 8, lg: 8 }} py={4}>
                        <Center>
                            <Heading size="lg" color="#007F4E">KẾT QUẢ KHÁM BỆNH</Heading>
                        </Center>

                        <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} spacing={4} mt={2}>
                            <Box borderRadius="4px" px={2} py={2} boxShadow="md">
                                <Text as="u" fontSize="16px" fontWeight="700">THÔNG TIN BỆNH NHÂN:</Text>

                                <Flex flexWrap="wrap" gap={2} mt={2}>
                                    <Flex flexDirection="column">
                                        <HStack mr={4}>
                                            <Text fontSize="16px" fontWeight="400">Họ tên:</Text>
                                            <Text fontSize="16px" fontWeight="700" color="#ff9800">{patientDetail?.name}</Text>
                                        </HStack>

                                        <HStack mr={4}>
                                            <Text fontSize="16px" fontWeight="400">Năm sinh:</Text>
                                            <Text fontSize="16px" fontWeight="700">{patientDetail?.yearOfBirth}</Text>
                                        </HStack>

                                        <HStack mr={4}>
                                            <Text fontSize="16px" fontWeight="400">Giới tính:</Text>
                                            <Text fontSize="16px" fontWeight="700">{patientDetail?.gender}</Text>
                                        </HStack>
                                    </Flex>

                                    <Flex flexDirection="column">
                                        <HStack mr={4}>
                                            <Text fontSize="16px" fontWeight="400">Số điện thoại:</Text>
                                            <Text fontSize="16px" fontWeight="700">{patientDetail?.phone}</Text>
                                        </HStack>

                                        <HStack mr={4}>
                                            <Text fontSize="16px" fontWeight="400">Căn cước công dân:</Text>
                                            <Text fontSize="16px" fontWeight="700">{patientDetail?.passport}</Text>
                                        </HStack>

                                        <HStack mr={4}>
                                            <Text fontSize="16px" fontWeight="400">Địa chỉ:</Text>
                                            <Text fontSize="16px" fontWeight="700">{patientDetail?.address}</Text>
                                        </HStack>
                                    </Flex>
                                </Flex>
                            </Box>

                            <Box borderRadius="4px" px={2} py={2} boxShadow="lg">
                                <Text as="u" fontSize="16px" fontWeight="700">THÔNG TIN BÁC SỸ KHÁM:</Text>

                                <Flex flexWrap="wrap" gap={2} mt={2}>
                                    <HStack mr={4}>
                                        <Text fontSize="16px" fontWeight="400">Bác sỹ:</Text>
                                        <Text fontSize="16px" fontWeight="700">{doctorDetail?.name}</Text>
                                    </HStack>

                                    <HStack mr={4}>
                                        <Text fontSize="16px" fontWeight="400">Ngày trả kết quả:</Text>
                                        { 
                                            date_return && 
                                            <Text fontSize="16px" fontWeight="700">
                                                <FormattedDate value={date_return} /> 
                                            </Text>    
                                        }
                                    </HStack>
                                </Flex>
                            </Box>
                        </SimpleGrid>

                        <Box borderRadius="4px" px={2} py={2} boxShadow="lg">
                            <Text as="u" fontSize="16px" fontWeight="700">KẾT QUẢ:</Text>

                            <Flex flexDirection="row" flexWrap="wrap" justify="flex-start" gap={2} mt={2}>
                                {
                                    results && Object.keys(results).map((key, idx) => {

                                        return (
                                            <HStack key={`result-${idx}`}>
                                                <Text fontSize="16px" fontWeight="400">{key}:</Text>
                                                <Text fontSize="16px" fontWeight="700">{results[key]}</Text>
                                            </HStack>
                                        )
                                    })
                                }
                            </Flex>
                                
                            <Box my={4}>
                                <Text as="u" fontSize="16px" fontWeight="700">ĐƠN THUỐC:</Text>
                                {
                                    medicine_results && medicine_results.map((medicineResult, idx) => {
                                        const { medicine_name, count, drink_morning, drink_afternoon, drink_night } = medicineResult;

                                        return (
                                            <Flex flexDirection="row" flexWrap="wrap" key={`medicine-result-${idx}`} gap={2} mb={2}>
                                                <HStack>
                                                    <Text fontSize="16px" fontWeight="400">Tên thuốc:</Text>
                                                    <Text fontSize="16px" fontWeight="700">{medicine_name}</Text>
                                                </HStack>

                                                <HStack>
                                                    <Text fontSize="16px" fontWeight="400">Số lượng:</Text>
                                                    <Text fontSize="16px" fontWeight="700">{count}</Text>
                                                </HStack>

                                                <HStack>
                                                    <Text fontSize="16px" fontWeight="400">Uống sáng:</Text>
                                                    <Text fontSize="16px" fontWeight="700">{drink_morning}</Text>
                                                </HStack>

                                                <HStack>
                                                    <Text fontSize="16px" fontWeight="400">Uống chiều:</Text>
                                                    <Text fontSize="16px" fontWeight="700">{drink_afternoon}</Text>
                                                </HStack>

                                                <HStack>
                                                    <Text fontSize="16px" fontWeight="400">Uống tối:</Text>
                                                    <Text fontSize="16px" fontWeight="700">{drink_night}</Text>
                                                </HStack>
                                            </Flex>
                                        )
                                    })
                                }
                                {
                                    (!medicine_results || (medicine_results && medicine_results.length === 0)) &&
                                    <Text color="red.700">Không có thông tin đơn thuốc!</Text>
                                }
                            </Box>

                            <Box my={4}>
                                <Text as="u" fontSize="16px" fontWeight="700">SỐ NGÀY ĐIỀU TRỊ: {cure_day}</Text>
                            </Box>

                            <Box my={4}>
                                <Text as="u" fontSize="16px" fontWeight="700" marginTop={4}>FILE ĐÍNH KÈM:</Text>
                                <List spacing={2}>
                                    {
                                        file_results && file_results.map((file, idx) => (
                                            <ListItem key={`file-${idx}`}>
                                                <HStack>
                                                    <ListIcon as={MdCheckCircle} color="green.500" />
                                                    <Link href={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/patient_results/${file}`} target="_blank" color="#1565c0">
                                                        {file}
                                                    </Link>
                                                </HStack>
                                            </ListItem>
                                        ))                                                        
                                    }
                                </List>
                                {
                                    (!file_results || (file_results && file_results.length === 0)) &&
                                    <Text color="red.700">Không có file đính kèm!</Text>
                                } 
                            </Box>

                            <Box my={4}>
                                <Text as="u" fontSize="16px" fontWeight="700" marginTop={4}>Các thực phấm/ chất cần kiêng cử:</Text>
                                <Flex gap={2}>
                                    {
                                        food_avoid && food_avoid.map((item, idx) => (
                                            <Text key={`food_avoid-${idx}`}>{item.value},</Text>
                                        ))                                                        
                                    }
                                </Flex>
                            </Box>
                        </Box>
                            
                        <Spacer />
                    </Box>
                </Box>
                {/* <Center> */}
                    {/* <VStack position="fixed" bottom="5px" px={4}> */}
                    <Flex flexDirection="column" px={4} align="center">
                        <Text fontSize={{ base: "18px", md: "24px", lg: "24px" }} fontWeight="700" color="#FE8B39">CHÚNG TÔI XIN TRÂN TRỌNG CẢM ƠN!</Text>
                        <Text fontSize={{ base: "14px", md: "18px", lg: "18px" }} fontWeight="700">
                            Mọi thắc mắc xin liên hệ phòng khám <span style={{color: "#ff9800"}}>{`${companyDetail?.name} (${companyDetail?.phone})`}</span>
                        </Text>
                    </Flex>
                {/* </Center> */}
            </Box>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {    
    const currentNavTab =           getCurrentNavTab(state);
    const patientResultDetail =     getAPatientResult(state);

    return { currentNavTab, patientResultDetail };
}

const mapDispatchToProps = (dispatch) => ({
    setNavTab:                              payload => dispatch(setNavTab(payload)),
    apiLoadAPatientResult:                  payload => dispatch(apiLoadAPatientResult(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisplayPatientResult);